import * as React from 'react'
import { Text, Inset, Icon } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import { BikeZeroTolerancePolicyImage } from '../../images'
import { ImageContainer, Box } from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'

const LIST_ITEMS = [
  {
    icon: <Icon type={Icon.Types.WineFill} size={Icon.Sizes.Medium} />,
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step4__au__sub_heading1__list_item1__zeroTolerancePolicy
    ),
  },
  {
    icon: <Icon type={Icon.Types.VehicleCar} size={Icon.Sizes.Medium} />,
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step4__au__sub_heading1__list_item2__zeroTolerancePolicy
    ),
  },
  {
    icon: <Icon type={Icon.Types.ProhibitedFill} size={Icon.Sizes.Medium} />,
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step4__au__sub_heading1__list_item3__zeroTolerancePolicy
    ),
  },
]

const stepName = 'ZeroTolerancePolicy'

export const ZeroTolerancePolicy = () => (
  <SectionContainer>
    <ImageContainer>
      <BikeZeroTolerancePolicyImage />
    </ImageContainer>
    <Text styles={Text.Styles.Bold32}>
      {i18n.t(
        i18nKeys.safetyCourse_bike_step4__au__heading__zeroTolerancePolicy
      )}
    </Text>
    <ContentText>
      {i18n.t(
        i18nKeys.safetyCourse_bike_step4__au__description1__zeroTolerancePolicy
      )}
    </ContentText>

    <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
      {i18n.t(
        i18nKeys.safetyCourse_bike_step4__au__sub_heading1__zeroTolerancePolicy
      )}
    </Text>

    {LIST_ITEMS.map((item, index) => (
      <Box
        key={`${stepName}_LIST_ITEMS_${index}`}
        display="flex"
        alignItems="flex-start"
      >
        {item.icon}
        <Box marginLeft={Inset.Sizes.XSmall}>
          <ContentText key={item.text}>{item.text}</ContentText>
        </Box>
      </Box>
    ))}

    <ContentText>
      {i18n.t(
        i18nKeys.safetyCourse_bike_step4__au__description2__zeroTolerancePolicy
      )}
    </ContentText>
  </SectionContainer>
)
